import { useLazyQuery } from "@apollo/client";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import plus from "../../svgs/plus-white.svg";
import {calculateYearsAndMonths, formatDateInput, formatPhoneNumber, formattedDate, getDurationInMonths, isGivenDateInCurrentYear, renderPrintFooter, useDebounce } from "../../utils";
import Icon from "../Icon/Icon";
import LinkComp from "../LinkComp/LinkComp";
import { AGENTS_COLUMNS, BUYERS_COLMNS, FIRMS_COLUMNS, Investors_COLMNS, LENDERS_COLUMNS, SELLERS_COLUMNS, TEAM_MEMBERS_1ST_LISTING_1ST_CLOSING_COLUMNS, TEAM_MEMBERS_CALL_LIST_COLUMNS, TEAM_MEMBERS_COLUMNS, TEAM_MEMBERS_ROSTER_COLUMNS, TEAM_MEMBERS_TERMINATED_COLUMNS, TENANTS_COLUMNS, VENDORS_COLUMNS } from "./Columns";
import DropdownWithFetch from './FetchColumnFilterOptions';
import "./SampleTable.css";
import "./SampleTable.scss";
import StaticDropdown from "./StaticDropdown";
// import MenuItem from '@mui/material/MenuItem';
import svgSortAsc from "../../svgs/arrow-up.svg";
import { GET_COMPANY_FIRM_QUERY } from "../Graphql/CompanyQueries/allCompanyQuery";
import { GET_BUYER_LIST_QUERY, GET_CONTACT_AGENTS_LIST_QUERY, GET_CONTACT_LENDERS_LIST_QUERY, GET_CONTACT_SELLERS_LIST_QUERY, GET_CONTACT_TEAM_LIST_QUERY, GET_CONTACT_TENANTS_LIST_QUERY, GET_CONTACT_VENDORS_LIST_QUERY, GET_INVESTOR_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import CustomDateRangePicker from "./CustomDateRangePicker";
import { browserHistory, Link } from "react-router";
import ExportCRM from "../CRM/ExportCRM";
import { UserContext } from "../Root/Root";
import { useCallback } from "react";
import SplitButton from "../SplitButton/SplitButton";
import SortTable from "../SortTable/SortTable";
import svgEdit from '../../svgs/edit.svg';
import {
  fetchRecordGroupMemberIds,
  fetchGroupContactListItems,
  filterGroupContactsByColumnFilters,
  filterVisibleGroupContacts,
  paginateArray,
  stripRecordGroupFilters,
} from "../RecordGroups/recordGroupsService";
import SearchPanel from "../SearchPanel/SearchPanel";
import InvestorForm from "../InvestorForm/InvestorForm";
import AgentForm from "../AgentForm/AgentForm";
import "../Filter/Filter.scss";

function getGroupIdFromUrl() {
  if (typeof window === "undefined") return "";
  return new URLSearchParams(window.location.search).get("group_id") || "";
}

function updateGroupIdInUrl(groupId) {
  if (typeof window === "undefined") return;
  var params = new URLSearchParams(window.location.search);
  if (groupId) {
    params.set("group_id", groupId);
  } else {
    params.delete("group_id");
  }
  var nextSearch = params.toString();
  browserHistory.push(window.location.pathname + (nextSearch ? "?" + nextSearch : ""));
}

const rosterColumns = [
  {
      code: 'IS_AGENT',
      name: 'Role',
      render: (el) => el.is_agent && el.is_agent==="y"?"Agent":el.is_agent==="h"?"AthCap - Agent":el.is_agent==="e"?"AthCap - Employee":"Employee",
  },
  {
      code: 'FIRST_NAME',
      name: 'Name',
      columnStyle: {
          minWidth: 150
      },
      render: (el) => el.first_name+" "+el.last_name,
  },
  {
      code: 'ADDRESS',
      name: 'Address',
      columnStyle: {
          minWidth: 230
      },
      render: (el) => el.address,
  },
  {
      code: 'CITY',
      name: 'City',
      render: (el) => el.city,
  },
  {
      code: 'STATE',
      name: 'State',
      render: (el) => el.state,
      className: 'paddingLeft'
  },
  {
      code: 'ZIP',
      name: 'ZIP',
      columnStyle: {
          minWidth: 80
      },
      render: (el) => el.zip,
  },
  {
      code: 'YRS_AT_STRIVE',
      name: 'Years At Strive',
      render: (el) => el.starting_date ? calculateYearsAndMonths(new Date(el.starting_date)) : '',
      className: 'paddingLeft55'
  },
  {
      code: 'STARTING_DATE',
      name: 'Start Date',
      render: (el) => el.starting_date ? formattedDate(el.starting_date):'',
  },
];


const callListColumns = [
  {
      code: 'IS_AGENT',
      name: 'Role',
      render: (el) => el.is_agent && el.is_agent==="y"?"Agent":el.is_agent==="h"?"AthCap - Agent":el.is_agent==="e"?"AthCap - Employee":"Employee",
  },
  {
      code: 'FIRST_NAME',
      name: 'Name',
      columnStyle: {
          minWidth: 150
      },
      render: (el) => el.first_name+" "+el.last_name,
  },
  {
      code: 'PHONE',
      name: 'Work Phone',
      columnStyle: {
          minWidth: 120
      },
      render: (el) => el.phone,
  },
  {
      code: 'CELL_PHONE',
      name: 'Cell Phone',
      columnStyle: {
          minWidth: 120
      },
      render: (el) => el.cell_phone,
  },
  {
      code: 'BIRTH_DATE',
      name: 'Birth Date',
      render: (el) => el.birth_date ? formattedDate(el.birth_date):'',
  }
];


const listingColumn = [
  {
      code: 'FIRST_NAME',
      name: 'Name',
      columnStyle: {
          minWidth: 150
      },
      render: (el) => el.first_name+" "+el.last_name,
  },
  {
      code: 'ON_PHONES',
      name: 'On Phones',
      render: (el) =>  el.on_phones && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool)) ? formattedDate(el.on_phones):'',
  },
  /*{
      code: 'IN_POOL',
      name: 'In Pools',                
      render: (el) => el.in_pool && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool))?formattedDate(el.in_pool):'',
  },*/
  {
      code: 'FIRST_LISTING',
      name: '1st Listing',
      render: (el) => el.first_listing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h")  ? formattedDate(el.first_listing):'',
  },
  {
      code: 'FIRST_CLOSING',
      name: '1st Closing',
      render: (el) => el.first_closing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h") ? formattedDate(el.first_closing):'',
  }
];

const defaultColumns = [
    {
        name: '',
        textAlign: 'center',
        columnStyle: {width: 70},
        // render: (el) => (
        //     <Link to={{ pathname: `${arc.path.base}teamMember/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
        // ),
        render: (el) => {
            const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
            const currentSearch = window.location.search;
            const currentPath = window.location.pathname + currentSearch;
          
            return (
              <Link to={{
                pathname: `${basePath}/teamMember/${el.contact_id}`,
                state: { fromListUrl: currentPath }
              }}>
                <Icon svg={svgEdit} />
              </Link>
            );
          }
    },
    {
        code: 'IS_AGENT',
        name: 'Role',
        render: (el) => el.is_agent && el.is_agent==="y"?"Agent":el.is_agent==="h"?"AthCap - Agent":el.is_agent==="e"?"AthCap - Employee":"Employee",
    },
    {
        code: 'FIRST_NAME',
        name: 'Name',
        columnStyle: {
            minWidth: 150
        },
        render: (el) => el.first_name+" "+el.last_name,
    },
    {
        code: 'PHONE',
        name: 'Work Phone',
        columnStyle: {
            minWidth: 120
        },
        render: (el) => el.phone,
    },

    {
        code: 'CELL_PHONE',
        name: 'Cell Phone',
        columnStyle: {
            minWidth: 120
        },
        render: (el) => el.cell_phone,
    },
    {
        code: 'STARTING_DATE',
        name: 'Start Date',
        render: (el) => el.starting_date ? formattedDate(el.starting_date):'',
    },
    {
        code: 'YRS_AT_STRIVE',
        name: 'Years At Strive',
        textAlign: 'center',
        render: (el) => el.starting_date ? calculateYearsAndMonths(new Date(el.starting_date)) : '',
    },
    {
        code: 'BIRTH_DATE',
        name: 'Birth Date',
        render: (el) => el.birth_date ? formattedDate(el.birth_date):'',
    },
    {
        code: 'ON_PHONES',
        name: 'On Phones',
        render: (el) =>  el.on_phones && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool)) ? formattedDate(el.on_phones):'',
    },
    /*{
        code: 'IN_POOL',
        name: 'In Pools',                
        render: (el) => el.in_pool && el.is_agent && (el.is_agent==="y" || el.is_agent==='h') && isGivenDateInCurrentYear(formattedDate(el.in_pool))?formattedDate(el.in_pool):'',
    },*/
    {
        code: 'FIRST_LISTING',
        name: '1st Listing',
        render: (el) => el.first_listing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h")  ? formattedDate(el.first_listing):'',
    },
    {
        code: 'FIRST_CLOSING',
        name: '1st Closing',
        render: (el) => el.first_closing && el.is_agent && (el.is_agent==="y" || el.is_agent==="h") ? formattedDate(el.first_closing):'',
    },
    {
        code: 'ADDRESS',
        name: 'Address',
        columnStyle: {
            minWidth: 230
        },
        render: (el) => el.address,
    },
    {
        code: 'CITY',
        name: 'City',
        render: (el) => el.city,
    },
    {
        code: 'STATE',
        name: 'State',
        render: (el) => el.state,
        className: 'textCenter'
    },
    {
        code: 'ZIP',
        name: 'ZIP',
        columnStyle: {
            minWidth: 80
        },
        render: (el) => el.zip,
    }
];

const TerminatedColumns = [
  {
      code: 'IS_AGENT',
      name: 'Role',
      render: (el) => el.is_agent && el.is_agent==="y"?"Agent":el.is_agent==="h"?"AthCap - Agent":el.is_agent==="e"?"AthCap - Employee":"Employee",
  },
  {
      code: 'FIRST_NAME',
      name: 'Name',
      columnStyle: {
          minWidth: 150
      },
      render: (el) => el.first_name+" "+el.last_name,
  },
  {
      code: 'TERMINATION_DATE',
      name: 'Termination Date',
      render: (el) => el.termination_date ? formattedDate(el.termination_date):'',
  },
  {
    code: 'YRS_AT_STRIVE',
    name: 'Years At Strive',
    render: (el) => el.starting_date ? calculateYearsAndMonths(new Date(el.starting_date)) : '',
    className: 'paddingLeft55'
},
];

function SampleTable() {
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [clear,setClear] = useState(false);
  const pathParts = (window.location.pathname || "").split("/");
  const rawModuleSegment = pathParts[pathParts.length - 1] || "";
  const moduleName = rawModuleSegment.split("?")[0];
    const [pageOptions, setPageOptions] = useState({
    pageIndex: 0,
    pageSize: moduleName === "team-members" ? 100 : 25,
    sortBy: [],
  });
  const listVal = listname()
  const supportsGroupFilter = moduleName === "agents" || moduleName === "investors";
  const isInvestor = moduleName === "investors";
  const isAgentList = moduleName === "agents";
  const initialGroupId = supportsGroupFilter ? getGroupIdFromUrl() : "";

  const initialFilters =
  listVal.toLowerCase() === 'team members'
    ? { terminated: false }
    : (initialGroupId ? { group_id: initialGroupId } : {});
  
  const [columnFilters, setColumnFilters] = useState(initialFilters); // State to hold column-specific filters
  const [debouncedFilters, setDebouncedFilters] = useState(initialFilters); // Debounced filters for API calls
  const apifilterData = useRef("");
  const groupMemberIdsRef = useRef(null);
  const activeGroupIdRef = useRef("");
  const fetchRequestIdRef = useRef(0);
  const skipTableEffectRef = useRef(false);
  const redirectVal = redirectToPageByName()
  const [exportData, setExportData] = useState([]) 
  const [dateMinMaxValue, setMinMaxDateValue] = useState({
    startDate: null,
    endDate: null,
  });
const [filterErrorMsg,setFilterErrorMsg] = useState("")
  const debouncedSetFilters = useDebounce((newFilters) => {
    setDebouncedFilters(newFilters); // Update debounced filters after delay
  }, 1000); // 500ms delay
  const [dropdownValues, setDropdownValues] = useState({});
  // Advanced slide-out filter (Investors dashboard only)
  const [advFilterQuery, setAdvFilterQuery] = useState(
    initialGroupId ? { group_id: initialGroupId } : {}
  );
  const [advPaneIndex, setAdvPaneIndex] = useState(0);
  const searchPanelRef = useRef(null);
  const [printType, setPrintType] = useState('All Fields');
  const [printColumns, setPrintColumns] = useState(defaultColumns);
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0)
  const [tableDataAllCount,setTableDataAllCount] = useState(0)
  const [width, setWidth] = useState(window.innerWidth);
  const [tableHeight, setTableHeight] = useState(600);
  const user = useContext(UserContext);
  const ownerAgentId = user && user.userData && user.userData.id;
 const sessionCrm = sessionStorage.getItem("isCrm") === "true";
 const lastViewTeamMember = sessionStorage.getItem('lastClickedTeamMember');
const getColumnStyle = (header) => {
  const baseStyle = {
    marginTop: "10px",
    backgroundColor: "white",
    fontFamily: "monospace",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  switch (header) {
    case "TENANT":
      return {
        ...baseStyle,
        display: "flex",
        width: "14ch",
      };
    case "ADDRESS":
      return {
        ...baseStyle,
        width: "250px",
      };
    case "COMPANY ADDRESS":
      return {
        ...baseStyle,
        width: "250px",
      };
      case "COMPANY":
      return {
        ...baseStyle,
        width: "250px",
      };
       case "CITY":
      return {
        ...baseStyle,
        width: "180px",
      };
      case "EMAIL" :
       return {
        ...baseStyle,
        width: "250px",
      };
    default:
      return {
        ...baseStyle,
        width: "14ch",
      };
  }
};

const allowedExportUsers = [
  "dmcneil@strivere.com",
  "jpierson@strivere.com",
  "jgreen@strivere.com",
  "jbavanam@sageitinc.com",
  "sfnu@strivere.com",
  "crussell@strivere.com",
];

const allowTerminationEmails = [
  "dmcneil@strivere.com",
  "jpierson@strivere.com",
  "jgreen@strivere.com",
  "jbavanam@sageitinc.com",
  "sfnu@strivere.com",
  "crussell@strivere.com",
];
const userEmail =
  user && user.userData && user.userData.email
    ? user.userData.email.toLowerCase()
    : "";


function scrollLastVisitedToView(lastVisitedId) {
  if (!lastVisitedId) return;

  const targetElement = document.querySelector(
    `.last_visited_contact[data-contact-id="${lastVisitedId}"]`
  );

  if (targetElement) {
    setTimeout(() => {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });

      // const originalBg = targetElement.style.backgroundColor;
      targetElement.style.transition = "background-color 0.5s ease";
      // targetElement.style.backgroundColor = "#ffff99"; // highlight

      // Keep highlight visible for 2s, then clear
      // setTimeout(() => {
      //   // targetElement.style.backgroundColor = originalBg || "";
      //   sessionStorage.removeItem("lastClickedTeamMember");
      // }, 2000);

    }, 100);
  }
}

scrollLastVisitedToView(lastViewTeamMember);

useEffect(() => {
  if (data && data.length > 0) {
    const timer = setTimeout(() => {
      sessionStorage.removeItem("lastClickedTeamMember");
    }, 1000); // 1 second after data is available

    return () => clearTimeout(timer); // cleanup if component unmounts
  }
}, [data]);

  // Calculate Total Count position based on screen width
  useEffect(() => {
    const calculatePosition = () => {
      const screenWidth = window.innerWidth;
      // Calculate right position to keep it visible within viewport
      // Use a percentage-based approach that scales with screen size
      let calculatedRight;
      
      if (screenWidth <= 1366) {
        calculatedRight = 30; // Smaller screens
      } else if (screenWidth <= 1920) {
        calculatedRight = 50; // Standard HD screens
      } else if (screenWidth <= 2560) {
        calculatedRight = 80; // 2K screens
      } else {
        calculatedRight = 120; // 4K and larger screens
      }
      setWidth(screenWidth);
    };

    calculatePosition();
    window.addEventListener('resize', calculatePosition);
    
    return () => window.removeEventListener('resize', calculatePosition);
  }, []);

  function listname() {
    const moduleMapping = {
      agents: "Agents",
      sellers: "Sellers",
      "team-members": "Team Members",
      firms: "Firms",
      tenants: "Tenants",
      lenders: "Lenders",
      buyers: "Buyers",
      investors: "Investors",
      vendors: "Vendors"
    };

    return moduleMapping[moduleName] || "-";
  }

  function getModuleQuery() {
    const queryMapping = {
      agents: GET_CONTACT_AGENTS_LIST_QUERY,
      //sellers: GET_CONTACT_SELLERS_LIST_QUERY,
      "team-members": GET_CONTACT_TEAM_LIST_QUERY,
      firms: GET_COMPANY_FIRM_QUERY,
      tenants: GET_CONTACT_TENANTS_LIST_QUERY,
      lenders: GET_CONTACT_LENDERS_LIST_QUERY,
      //buyers: GET_BUYER_LIST_QUERY,
      investors: GET_INVESTOR_LIST_QUERY,
      vendors: GET_CONTACT_VENDORS_LIST_QUERY,
    };

    return queryMapping[moduleName] || null;
  }


  function redirectToPageByName() {
    const pageMapping = {
      agents: "agent",
      //sellers: "seller",
      "team-members": "teamMember",
      firms: "firm",
      tenants: "tenant",
      lenders: "lender",
      //buyers: "buyer",
      investors:"investor",
      vendors:"vendor"
    };

    return pageMapping[moduleName] || "-";
  }

  function dynamicallyColumns() {
    const columnsMapping = {
      agents: AGENTS_COLUMNS,
      //sellers: SELLERS_COLUMNS,
      "team-members": TEAM_MEMBERS_COLUMNS,
      firms: FIRMS_COLUMNS,
      tenants: TENANTS_COLUMNS,
      lenders: LENDERS_COLUMNS,
      //buyers: BUYERS_COLMNS,
      investors:Investors_COLMNS,
      vendors:VENDORS_COLUMNS
    };

    return columnsMapping[moduleName] || null;
  }

function moduleType(name) {
  const moduleQueryMapping = {
    agents: "Agent",
    "team-members": "Team",
    firms: "Firm",
    tenants: "Tenant",
    lenders: "Lender",
    investors: "Investor",
    vendors: "Vendor",
  };
  return moduleQueryMapping[name] || "";
}

const [columns, setColumns] = useState(dynamicallyColumns());

useEffect(() => {
    const urlGroupId = supportsGroupFilter ? getGroupIdFromUrl() : "";
    const resetFilters =
      listVal.toLowerCase() === "team members"
        ? { terminated: false }
        : urlGroupId
          ? { group_id: urlGroupId }
          : {};
    groupMemberIdsRef.current = null;
    activeGroupIdRef.current = urlGroupId || "";
    setColumnFilters(resetFilters);
    setDebouncedFilters(resetFilters);
    apifilterData.current = ""
    setMinMaxDateValue({
      startDate: null,
      endDate: null,
    })
    setFilterErrorMsg("")    
    setPageOptions({
    pageIndex: 0,
    pageSize: moduleName === "team-members" ? 100 : 25,
    sortBy: [],
  });
    setDropdownValues({});
    setAdvFilterQuery({});
    setAdvPaneIndex(0);
    setClear((prev) => !prev);
}, [location.pathname,moduleTypeName]);

const moduleTypeName = useMemo(() => {
  return moduleName ? moduleType(moduleName) : ""; // your mapping function
}, [moduleName]);

  // const columns = useMemo(() => dynamicallyColumns(), [moduleTypeName]);
  const token = localStorage.getItem("authToken");

const lastDeps = useRef({});

useEffect(() => {
  if (!moduleTypeName) return;

  const activeGroupId = debouncedFilters.group_id;
  if (supportsGroupFilter && activeGroupId && !ownerAgentId) {
    return;
  }

  // Build current dep state
  const currentDeps = {
    pageOptions,
    debouncedFilters,
    moduleTypeName,
    ownerAgentId: ownerAgentId || null,
  };

  // Compare with last deps to see if *real* change happened
  const sameDeps = JSON.stringify(currentDeps) === JSON.stringify(lastDeps.current);

  if (sameDeps) return; // Skip if nothing actually changed

  lastDeps.current = currentDeps; // Save for next run

  fetchData(moduleTypeName);
}, [pageOptions, debouncedFilters, moduleTypeName, ownerAgentId, supportsGroupFilter]);


  useEffect(() => {
    if(moduleTypeName){
      setColumns(dynamicallyColumns())
      if(listVal.toLowerCase() === 'team members'){
        setPrintType('All Fields')
        setTotalCount(items.length)
        setItems(data)
        setPrintColumns(defaultColumns)
        // setColumnFilters({terminated: false})  //no need now intially we updated
        setDropdownValues({});
        // debouncedSetFilters({...columnFilters, terminated: false}) //no need now intially we updated
      }
      
    }
  }, [moduleTypeName]);

  const moduleQuery = useMemo(function() {
    return getModuleQuery() || GET_INVESTOR_LIST_QUERY;
  }, [moduleName]);

  const [getQuery, { data: tableAllData, loading: queryLoading, error }] =
    useLazyQuery(moduleQuery, {
      fetchPolicy: "no-cache",
      context: {
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    });
  function parseQueryResultFromData(queryData) {
    const tableQueryData = {
      totalCount: 0,
      tableData: [],
    };
    if (queryData && queryData.getContacts && queryData.getContacts.success && queryData.getContacts.data.length > 0) {
      tableQueryData.tableData.push(...queryData.getContacts.data);
      tableQueryData.totalCount = queryData.getContacts.totalCount;
      setTableDataAllCount(queryData.getContacts.totalCount);
    } else if (queryData && queryData.getCompanies && queryData.getCompanies.success && queryData.getCompanies.data.length > 0) {
      tableQueryData.tableData.push(...queryData.getCompanies.data);
      tableQueryData.totalCount = queryData.getCompanies.totalCount;
      setTableDataAllCount(queryData.getCompanies.totalCount);
    }
    return tableQueryData;
  }

  function responseData() {
    return parseQueryResultFromData(tableAllData);
  }

  function buildFinalTableRows(tableData, totalCount, currentPageOptions) {
    const { sortBy } = currentPageOptions;
    let finalData = tableData;
    let resolvedTotalCount = totalCount;

    if (sortBy && sortBy.length > 0 && sortBy[0].id === "termination_date") {
      const desc = sortBy[0].desc;
      finalData = [...tableData].sort((a, b) => {
        const dateA = a.termination_date
          ? new Date(a.termination_date)
          : new Date(a.arcimedes_modified);
        const dateB = b.termination_date
          ? new Date(b.termination_date)
          : new Date(b.arcimedes_modified);

        if (dateA < dateB) return desc ? 1 : -1;
        if (dateA > dateB) return desc ? -1 : 1;
        return 0;
      });
    } else if (sortBy && sortBy.length > 0 && sortBy[0].id === "yrs_at_strive") {
      const desc = sortBy[0].desc;
      finalData = [...tableData].sort((a, b) => {
        const durA = getDurationInMonths(a.starting_date, a.termination_date, a.arcimedes_modified);
        const durB = getDurationInMonths(b.starting_date, b.termination_date, b.arcimedes_modified);

        if (durA < durB) return desc ? 1 : -1;
        if (durA > durB) return desc ? -1 : 1;
        return 0;
      });
    }

    return { finalData, resolvedTotalCount };
  }

  function applyTableResults(tableData, totalCount, currentPageOptions) {
    const { finalData, resolvedTotalCount } = buildFinalTableRows(
      tableData,
      totalCount,
      currentPageOptions
    );
    const pageSize = currentPageOptions.pageSize;
    setData(finalData);
    setExportData(finalData);
    setPageCount(Math.ceil(resolvedTotalCount / pageSize));
    setItems(finalData);
    setTotalCount(resolvedTotalCount);
    setTimeout(calculateTableHeight, 100);
  }

const fetchData = async (type) => {
  if (!type) return;

  const fetchRequestId = ++fetchRequestIdRef.current;
  setLoading(true);

  const { pageIndex, pageSize, sortBy } = pageOptions;

const sortOptions = sortBy.length > 0
  ? sortBy.map((sort) => ({
      field: sort.id,
      order: sort.desc ? "desc" : "asc",
    }))
  : [];

  let apiFilters = Object.entries(debouncedFilters).reduce((acc, [field, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      // Filter fields are String-typed in the GraphQL schema (e.g. strive_agent),
      // but some entry points (advanced filter panel) supply a numeric id. Coerce
      // numbers to strings so the server doesn't reject the query. Booleans (e.g.
      // `terminated`) are left as-is.
      acc[field] = typeof value === "number" ? value.toString() : value;
    }
    return acc;
  }, {});

  const ownerAgentId = user && user.userData && user.userData.id;
  const activeGroupId = apiFilters.group_id;
  let memberIds = null;

  if (!supportsGroupFilter || !activeGroupId || !ownerAgentId) {
    groupMemberIdsRef.current = null;
    activeGroupIdRef.current = "";
  } else {
    const groupChanged = activeGroupIdRef.current !== String(activeGroupId);
    if (groupChanged) {
      groupMemberIdsRef.current = null;
      activeGroupIdRef.current = String(activeGroupId);
    }
    memberIds = groupMemberIdsRef.current;
    if (!memberIds) {
      memberIds = await fetchRecordGroupMemberIds("people", ownerAgentId, activeGroupId);
      if (fetchRequestId !== fetchRequestIdRef.current) {
        return;
      }
      groupMemberIdsRef.current = memberIds;
    }
    if (!memberIds.length) {
      setData([]);
      setExportData([]);
      setItems([]);
      setTotalCount(0);
      setPageCount(0);
      setTableDataAllCount(0);
      setLoading(false);
      return;
    }
  }

  apiFilters = stripRecordGroupFilters(apiFilters);

  if (memberIds && memberIds.length) {
    const groupContacts = await fetchGroupContactListItems(memberIds);
    if (fetchRequestId !== fetchRequestIdRef.current) {
      return;
    }
    const groupRows = filterGroupContactsByColumnFilters(
      filterVisibleGroupContacts(groupContacts),
      apiFilters
    );
    const pageRows = paginateArray(groupRows, pageIndex + 1, pageSize);
    setData(pageRows);
    setExportData(groupRows);
    setItems(pageRows);
    setTotalCount(groupRows.length);
    setPageCount(Math.ceil(groupRows.length / pageSize));
    setTableDataAllCount(groupRows.length);
    setTimeout(calculateTableHeight, 100);
    setLoading(false);
    return;
  }

  await getQuery({
    variables: {
      type,
      pageOptions: {
        page: pageIndex + 1,
        pageSize,
      },
      sortOptions,
      filters: [apiFilters],
    },
  });

  if (fetchRequestId !== fetchRequestIdRef.current) {
    return;
  }

  // Group rows are handled above; anything reaching here is a plain paged list,
  // which the tableAllData effect renders.
  setLoading(false);
};




useEffect(() => {
  if (!tableAllData) return;
  if (debouncedFilters.group_id) return;

  const { tableData, totalCount } = responseData();
  applyTableResults(tableData, totalCount, pageOptions);
}, [tableAllData, pageOptions, calculateTableHeight, debouncedFilters.group_id]);


  const handleSortChange = (column) => {
    const querySort =  column.rowType
    ? column.rowType === "MT"
      ? "multi_tenant_subcategory"
      : "single_tenant_subcategory"
    : column.sortParam;
    setPageOptions((prev) => {
      const existingSort = prev.sortBy.find((sort) => sort.id === querySort);

      let updatedSortBy;
      if (!existingSort) {
        updatedSortBy = [...prev.sortBy, { id: querySort, desc: false }];
      } else if (existingSort.desc === false) {
        updatedSortBy = prev.sortBy.map((sort) =>
          sort.id === querySort ? { ...sort, desc: true } : sort
        );
      } else {
        updatedSortBy = prev.sortBy.filter((sort) => sort.id !== querySort);
      }

      return { ...prev, sortBy: updatedSortBy, pageIndex: 0 };
    });
  };

  const handleFilterChange = (column, value) => {
    const phoneColumns = ['phone', 'cell phone', 'work phone','phone #'];
    const dateColumns = ['1st closing', '1st listing', 'in pools', 'on phones', 'birth date'];
    const dateType = dateColumns.some(keyword => column.Header.toLowerCase() === keyword);
    const phoneType = phoneColumns.some(keyword => column.Header.toLowerCase() === keyword);
    const formattedValue = phoneType ? formatPhoneNumber(value) : dateType ? formatDateInput(value) : value;
    const updatedFilters = {
      ...columnFilters, 
      [column.queryParam]: formattedValue,
    };
    setColumnFilters(updatedFilters); // Update immediate filters for UI
    //handled teh api calling when other than number enters in the phone inputs
    let check = (phoneType || dateType);
    if(check && updatedFilters[column.queryParam] == ""){
      return;
    }
    else{
      debouncedSetFilters(updatedFilters); // Pass filters to the debounced function
    }
  };
 const handlePlaceholderNameCheck = (columnName) => {
    const dateColumns = new Set([
        '1st closing', 
        '1st listing', 
        'in pools', 
        'on phones', 
        'birth date'
    ]);

    return dateColumns.has(columnName.toLowerCase()) ? "MM/DD/YYYY" : columnName;
};
  const handleDropDownValue = (column, selectedOption) => {
    const value = selectedOption ? selectedOption.code : undefined;
    const queryParam = column.rowType
      ? column.rowType === "MT"
        ? "multi_tenant_subcategory"
        : "single_tenant_subcategory"
      : column.queryParam;

    const updatedFilters = {
      ...columnFilters,
      [queryParam]: typeof value === "number" ? value.toString() : value,
    };
    setDropdownValues((prev) => ({ ...prev, [column.queryParam]: selectedOption }));
    // Update filters with debouncing and immediate UI updates
    debouncedSetFilters((prev) => ({
      ...prev,
      [queryParam]: typeof value === "number" ? value.toString() : value,
    }));
    setColumnFilters(updatedFilters);
  };

  const handleClear = () => {
    setColumnFilters({})
    setDebouncedFilters({})
    setAdvFilterQuery({})
    apifilterData.current = ""
    groupMemberIdsRef.current = null;
    activeGroupIdRef.current = "";
    if (supportsGroupFilter) {
      updateGroupIdInUrl("");
    }
    setMinMaxDateValue({
      startDate: null,
      endDate: null,
    })
    setFilterErrorMsg("")    
    setPageOptions({
    pageIndex: 0,
    pageSize: moduleName === "team-members" ? 100 :  25,
    sortBy: [],
  });
    setDropdownValues({});
    setClear((prev) => !prev);
  }

  // ----- Advanced slide-out filter handlers (Investors dashboard) -----
  const handleAdvParentChange = (key, value) => {
    setAdvFilterQuery((prev) => ({ ...prev, [key]: value }));
  };

  const handleAdvParentDropdownChange = (query) => {
    const updated = { ...query };
    if (updated.type !== undefined) {
      delete updated.single_tenant_subcategory;
      delete updated.multi_tenant_subcategory;
    }
    setAdvFilterQuery(updated);
  };

  const handleAdvancedApply = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const cleaned = Object.entries(advFilterQuery).reduce((acc, [k, v]) => {
      if (v !== undefined && v !== null && v !== "") acc[k] = v;
      return acc;
    }, {});
    const next = cleaned;
    if (supportsGroupFilter) {
      const nextGroupId = next.group_id ? String(next.group_id) : "";
      if (activeGroupIdRef.current !== nextGroupId) {
        groupMemberIdsRef.current = null;
        setData([]);
        setItems([]);
      }
      activeGroupIdRef.current = nextGroupId;
      updateGroupIdInUrl(nextGroupId);
    }
    setColumnFilters(next);
    setDebouncedFilters(next);
    setDropdownValues({});
    setMinMaxDateValue({ startDate: null, endDate: null });
    setFilterErrorMsg("");
    setPageOptions({
      pageIndex: 0,
      pageSize: moduleName === "team-members" ? 100 : 25,
      sortBy: [],
    });
    setClear((prev) => !prev);
    if (searchPanelRef.current) searchPanelRef.current.close();
  };

  const handleAdvancedClear = () => {
    setAdvFilterQuery({});
    handleClear();
  };

  const handleSortIdMatch = (sort, column) => {
   if(sort.id === "single_tenant_subcategory"){
      var sort = "SUBCATEGORY" === column.Header
      return sort;
    }
    else if(sort.id === "strive_agent_last_name"){
      var sort = "AGENT" === column.Header
      return sort;
    }
    else if(sort.id === "first_name"){
      var sort =  column.Header === "NAME" || column.Header == "FIRST NAME" || column.Header == "CONTACT FIRST NAME"
      return sort;
    } else if(sort.id === "starting_date"){
      var sort = "START DATE" === column.Header
      return sort;
    }
    else {
      var sort = sort.id === column.queryParam
      return sort;
    }
  }

  const handleNavigation = () => {
    const path = moduleName === "firms" ? "/company" : "/contacts";
    browserHistory.push(path);
    sessionStorage.removeItem("isCrm");
  };

  useEffect(() => {
    apifilterData.current = debouncedFilters; // Update ref with debounced filters
    setPageOptions((prev) => ({
      ...prev,
      pageIndex: 0,
      pageSize: moduleName === "team-members" ? 100 :  25,
    }));
    fetchData(moduleTypeName); // Call API whenever debounced filters change
  }, [moduleTypeName]);

  const tableInstance = useTable(
    {
      columns,
      data,
      manualPagination: true,
      manualSortBy: true,
      pageCount,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, pageSize },
  } = tableInstance;
  const isLoading = loading || queryLoading;
  const handlePageChange = (newPageIndex) => {
    setPageOptions((prev) => ({
      ...prev,
      pageIndex: newPageIndex,
    }));
    gotoPage(newPageIndex); // Sync table's internal state
  };
  const hasValidFilters = Object.entries(columnFilters || {}).some(function(entry) {
    return entry[1] !== undefined && entry[1] !== null && entry[1] !== "";
  });


  const handleDropdownChange=(option)=>{
          switch (option) {
              case 'Roster':
                  setPrintType('Roster');
                  setTotalCount(items.length);
                  setItems(data);
                  setPrintColumns(rosterColumns);
                  setColumns(TEAM_MEMBERS_ROSTER_COLUMNS)
                  setColumnFilters({terminated: false})
                  setDropdownValues({});
                  debouncedSetFilters({...columnFilters, terminated: false})
                  break;
              case 'Call List':
                  setPrintType('Call List');
                  setTotalCount(items.length);
                  setItems(data);
                  setPrintColumns(callListColumns)
                  setColumns(TEAM_MEMBERS_CALL_LIST_COLUMNS)
                  setColumnFilters({terminated: false})
                  setDropdownValues({});
                  debouncedSetFilters({...columnFilters, terminated: false})
                  break;
              case '1st Listing & 1st Closing':{
                  const agentsList = data.filter(item => item.is_agent === 'y')
                  setPrintType('1st Listing & 1st Closing')
                  setTotalCount(agentsList.length)
                  setItems(agentsList)
                  setPrintColumns(listingColumn)
                  setColumns(TEAM_MEMBERS_1ST_LISTING_1ST_CLOSING_COLUMNS)
                  setColumnFilters({terminated: false})
                  setDropdownValues({});
                  debouncedSetFilters({...columnFilters, terminated: false})
                  break;
              }case 'All Fields':
                  setPrintType('All Fields')
                  setTotalCount(items.length)
                  setItems(data)
                  setPrintColumns(defaultColumns)
                  setColumns(TEAM_MEMBERS_COLUMNS)
                  setColumnFilters({terminated: false})
                  setDropdownValues({});
                  debouncedSetFilters({...columnFilters, terminated: false})
                  break;
              case 'Terminated':
                  setPrintType('Terminated')
                  setTotalCount(items.length)
                  setItems(data)
                  setPrintColumns(TerminatedColumns)
                  setColumns(TEAM_MEMBERS_TERMINATED_COLUMNS)
                  setColumnFilters({terminated: true})
                  setDropdownValues({});
                  debouncedSetFilters({...columnFilters, terminated: true})
                  break;
          }
  }

  const renderPrintPage = () => {
          // const splitObjectIntoChunks = (entries, chunkSize = 8) => {
          //     return Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
          //      entries.slice(i * chunkSize, (i + 1) * chunkSize)
          //     );
          //   };
          const splitObjectIntoChunks = (entries, chunkSize = 8) => {
              if (!Array.isArray(entries)) return [];
            
              return Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
                entries.slice(i * chunkSize, (i + 1) * chunkSize)
              );
            };
          // Split rows into chunks
          const rowChunks = splitObjectIntoChunks(items);
          return (
              <React.Fragment>
              {rowChunks.map((rowChunk, chunkIndex) => (
                      <div className='print-container'  key={chunkIndex} style={{background: `url('${arc.path.media+'Transaction_Background.png'}')`}} >
                          {chunkIndex === 0 && <div className='TeamMemberList_head_left'>
                              <h3 className='TeamMemberList_h3'>{listVal.toLowerCase() === "firms" ? "Companies" : listVal} - {totalCount}</h3>
                          </div>}
                          <div className={`table-print-container ${chunkIndex !== 0 && 'marginTop50'}`}>
                              <SortTable columns={printColumns}
                                      items={rowChunk}
                                      query={location.query}
                              />
                          </div>
                          {renderPrintFooter(true)}
                      </div>
             
               ))}
                </React.Fragment>
          )
      }


      const updateWindowDimensions = useCallback(() => {
        setWidth(window.innerWidth);
        calculateTableHeight();
      }, []);

      const calculateTableHeight = useCallback(() => {
        // Calculate available height dynamically
        const headerElement = document.querySelector('.page-header-container');
        const headerHeight = headerElement ? headerElement.offsetHeight : 100;
        const paginationHeight = 80; // Approximate height for pagination controls
        const padding = 40; // Additional padding/margins
        const availableHeight = window.innerHeight - headerHeight - paginationHeight - padding;
        
        // Set minimum height to prevent table from being too small
        const minHeight = 400;
        const calculatedHeight = Math.max(availableHeight, minHeight);
        
        setTableHeight(calculatedHeight);
      }, []);
    
      useEffect(() => {
          updateWindowDimensions();
          calculateTableHeight();
          window.addEventListener('resize', updateWindowDimensions);
          return () => {
            window.removeEventListener('resize', updateWindowDimensions);
          };
      }, [updateWindowDimensions,calculateTableHeight]);
   const allowTerminationUsers =
     user &&
     user.userData &&
     user.userData.email &&
     allowTerminationEmails.includes(user.userData.email.toLowerCase());
  return (
    <div>
      <div className="TeamMemberList">
        <div className="page-body-container" style={{ paddingTop: "15px" }}>
          {sessionCrm && (
            <div
              className="page-back-button"
              onClick={() => {
                handleNavigation();
                // //  history.back();
                // if(moduleName == "firms"){
                // browserHistory.push("/company");
                // }
                // else browserHistory.push("/contacts");
              }}
            >
              <Icon svg={svgSortAsc} />
              {moduleName == "firms" ? "Companies" : "Contacts"}
            </div>
          )}
          <div>
            <div
              className="page-header-container list"
              style={{ padding: "0px" }}
            >
              <div className="page-header list">
                <div
                  className="page-title"
                  style={{
                    minWidth:
                      listVal.toLowerCase() === "team members"
                        ? "240px"
                        : "unset",
                  }}
                >
                  {listVal.toLowerCase() === "firms" ? "Companies" : listVal}
                </div>
                <LinkComp
                  //  to={`${arc.path.base}${redirectVal}` }
                  to={{
                    pathname: `${arc.path.base}${redirectVal}`,
                    state: {
                      fromListUrl:
                        window.location.pathname + window.location.search,
                    },
                  }}
                >
                  <div
                    className="button-new plus positive"
                    style={{ marginRight: "10px" }}
                  >
                    <Icon svg={plus} />
                  </div>
                </LinkComp>
                <button
                  style={{ marginRight: "10px" }}
                  // style={{ position: "absolute", left: "10px" }}
                  className="button-new negative margin-left"
                  onClick={handleClear}
                  disabled={
                    pageOptions.sortBy &&
                    pageOptions.sortBy.length === 0 &&
                    !hasValidFilters
                  }
                >
                  Clear
                </button>
                <div>
                  {allowedExportUsers.includes(userEmail) && (
                    <ExportCRM
                      exportData={exportData}
                      setExportData={setExportData}
                      printType={printType}
                    />
                  )}
                </div>
                {listVal.toLowerCase() === "team members" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      width: width - (allowTerminationUsers ? 658 : 566),
                    }}
                  >
                    <SplitButton
                      icon={printType === "All Fields" ? false : true}
                      options={
                        allowTerminationUsers
                          ? [
                              "All Fields",
                              "Roster",
                              "Call List",
                              "1st Listing & 1st Closing",
                              "Terminated",
                            ]
                          : [
                              "All Fields",
                              "Roster",
                              "Call List",
                              "1st Listing & 1st Closing",
                            ]
                      }
                      onChange={handleDropdownChange}
                      selectedOption={printType}
                      onClick={() =>
                        printType !== "All Fields" && window.print()
                      }
                    />
                  </div>
                )}
              </div>
              {/* {listVal.toLowerCase() === "team members" &&
( <div style={{ display: "flex", marginLeft:"80px",flexDirection: "column", alignItems: "flex-start" }}>
    <span style={{ fontSize: "22px", color: "#7EB233", fontWeight: "bold", marginTop: "2px" }}>
   {tableDataAllCount}
    </span>
  </div>)} */}
              <div className="line" />
              <div style={{ marginTop: "25px" }}>
                {(error || filterErrorMsg) && (
                  <div style={{ color: "red" }}>
                    {error && error.message ? error.message : filterErrorMsg}
                  </div>
                )}
              </div>
            </div>
          </div>
   <div style={{ overflowY: 'auto', height: `${tableHeight}px` }}>
  <table className="reusable-table" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, index) =>
                    (index === 0 && column.Header === "VIEW/EDIT") ||
                    (moduleTypeName !== "Team" && index === 1) ? (
                      // This is for the first column where we don't want arrows
                      <th
                        {...column.getHeaderProps()}
                        style={{
                           position: "sticky", // ✅ Make header sticky
                            top: "-1px", // ✅ Stick to top
                            zIndex: 2, // ✅ Stay above tbody content
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          cursor: "pointer",
                          color: "rgb(100, 100, 100)",
                          fontSize: "14px",
                          fontWeight: 600,
                          fontFamily: '"Open Sans", sans-serif',
                          // paddingTop: "18px",
                          // paddingBottom: "18px",
                          textAlign: "center",
                          background:"#DBDBDB",
                          width: "50px", // Center the content in each header
                        }}
                      >
                        {/* <div className= {column.Header === "VIEW" ? "custom-header-tenant":""}>{column.render("Header")}</div> */}
                        <div>{column.render("Header")}</div>
                      </th>
                    ) : (
                      // This is for all other columns where we want to show the arrows
                      <th
                        {...column.getHeaderProps()}
                        onClick={(e) => {
                          if (e.target.tagName !== "INPUT") {
                            handleSortChange(column);
                          }
                        }}
                        style={
                          columns.some((item) => item.cascadeColumns === true)
                            ? {
                               position: "sticky", // ✅ Make header sticky
                              top: "-1px", // ✅ Stick to top
                              zIndex: 2, // ✅ Stay above tbody content
                               overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                             background:"#DBDBDB",
                                cursor: "pointer",
                                color: "rgb(100, 100, 100)",
                                fontSize: "14px",
                                fontWeight: 600,
                                fontFamily: '"Open Sans", sans-serif',
                                // paddingTop: "8px",
                                // paddingBottom: "8px",
                                textAlign: "center", // Center the content in each header
                              }
                            : {
                               position: "sticky", // ✅ Make header sticky
                              top: "-1px", // ✅ Stick to top
                              zIndex: 2, // ✅ Stay above tbody content
                               overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                             background:"#DBDBDB",
                                cursor: "pointer",
                                color: "rgb(100, 100, 100)",
                                fontSize: "14px",
                                fontWeight: 600,
                                fontFamily: '"Open Sans", sans-serif',
                                // paddingTop: "18px",
                                // paddingBottom: "18px",
                                textAlign: "center", // Center the content in each header
                              }
                        }
                        className={
                          column.Header === "TENANT" ? "tenant-header" : ""
                        }
                      >
                        <div
                          style={
                            column.Header === "TENANT"
                              ? {
                                  width: "fit-content",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }
                              : {
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                }
                          }
                        >
                          <span
                            style={{
                              fontSize: "12px",
                              color: (() => {
                                const sort = pageOptions.sortBy.find(
                                  // (sort) => sort.id === column.id.toLowerCase()
                                  (sort) => handleSortIdMatch(sort, column)
                                );
                                if (sort && !sort.desc) return "#90C54B"; // Apply green if it's ascending
                                return "inherit"; // No green for other cases
                              })(),
                            }}
                          >
                            {(() => {
                              const sort = pageOptions.sortBy.find(
                                (sort) => sort.id === column.id
                              );
                              return "▲"; // Show correct arrow
                            })()}
                          </span>
                          <div>{column.render("Header")}</div>
                          <span
                            style={{
                              fontSize: "12px",
                              color: (() => {
                                const sort = pageOptions.sortBy.find(
                                  // (sort) => sort.id === column.id.toLowerCase()
                                  (sort) => handleSortIdMatch(sort, column)
                                );
                                if (sort && sort.desc) return "#90C54B"; // Apply green if it's ascending
                                return "inherit"; // No green for other cases
                              })(),
                            }}
                          >
                            {(() => {
                              const sort = pageOptions.sortBy.find(
                                (sort) => sort.id === column.id
                              );
                              return "▼"; // Show correct arrow
                            })()}
                          </span>
                        </div>
                      </th>
                    )
                  )}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {/* Filter Row (First Row) */}
              <tr
                style={{
                  fontFamily: '"Open Sans", sans-serif',
                  borderBottom: "1px solid #ddd", // Add vertical line below the first row
                  minHeight: "40px", // Use minHeight to set the filter row height to 40px
                  height: "auto", // Let the height auto-adjust to content
                }}
              >
                {columns.map((column, index) => (
                  <React.Fragment key={index}>
                    {
                      <td
                        style={{
                          // paddingTop:"2px",
                          paddingTop: "2px",
                          minHeight: "40px", // Ensuring main column filter row is shorter
                          // padding: "8px", // Reduced padding for a shorter row
                          border: "none", // Remove vertical line for the filter row
                          verticalAlign: "middle",
                        }}
                      >
                        {/* Display filter options for the main column */}
                        {column.isInputFilter && (
                          <div
                            style={
                              column.alignStyle && column.alignStyle == "center"
                                ? {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                  }
                                : {}
                            }
                          >
                            {column.filterType === "Dropdown" ? (
                              <div
                                style={
                                  column.Header === "COMPANY"
                                    ? { width: "250px", marginTop: "10px" }
                                    : { width: "182px", marginTop: "10px" }
                                }
                              >
                                {/* <div
                              //   style={{ width: "14ch", marginTop: "10px",fontSize:"small" }}
                              // > */}
                                <DropdownWithFetch
                                  onChange={(selectedOption) =>
                                    handleDropDownValue(column, selectedOption)
                                  }
                                  token={token}
                                  value={
                                    dropdownValues[column.queryParam] || null
                                  }
                                  query={column.query}
                                  queryType={column.queryType}
                                  cleared={clear}
                                  filters={column.filters ? column.filters : {}}
                                />
                              </div>
                            ) : column.filterType === "Static Dropdown" ? (
                              <div
                                style={{ marginTop: "12px", width: "182px" }}
                              >
                                {/* <div
                                style={{ marginTop: "12px", width: "14ch",fontSize:"small" }}
                              > */}
                                <StaticDropdown
                                  options={column.dropDownOptions}
                                  onChange={(selectedOption) =>
                                    handleDropDownValue(column, selectedOption)
                                  }
                                  placeholder="Select"
                                  value={
                                    dropdownValues[column.queryParam] || null
                                  }
                                  cleared={clear}
                                />
                              </div>
                            ) : column.filterType === "datepicker" ? (
                              <div>
                                <CustomDateRangePicker
                                  dateMinMaxValue={dateMinMaxValue}
                                  setMinMaxDateValue={setMinMaxDateValue}
                                  setColumnFilters={setColumnFilters}
                                  columnData={column}
                                  columnFilters={columnFilters}
                                  debouncedSetFilters={debouncedSetFilters}
                                  setDebouncedFilters={setDebouncedFilters}
                                  setFilterErrorMsg={setFilterErrorMsg}
                                  filterErrorMsg={filterErrorMsg}
                                />
                              </div>
                            ) : (
                              <input
                                type="text"
                                placeholder={handlePlaceholderNameCheck(
                                  column.Header
                                )}
                                value={columnFilters[column.queryParam] || ""}
                                // maxLength={14} // Restrict input to 14 characters
                                onChange={(e) =>
                                  handleFilterChange(column, e.target.value)
                                }
                                style={getColumnStyle(column.Header)}
                                title={columnFilters[column.queryParam] || ""} // Tooltip with full text
                              />
                            )}
                          </div>
                        )}
                      </td>
                      //)
                    }
                  </React.Fragment>
                ))}
              </tr>

              {/* Data Rows */}
              {isLoading ? (
                <tr>
                  <td
                    colSpan={columns.length + 1}
                    style={{
                      textAlign: "center",
                      height: "60px", // Consistent height for loading row
                      fontSize: "13px",
                      fontFamily: '"Open Sans", sans-serif',
                    }}
                  >
                    Loading...
                  </td>
                </tr>
              ) : page.length > 0 ? (
                page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      style={{
                        borderBottom: "1px solid #ddd",
                        height: "60px", // Ensuring data row height is 60px
                        fontSize: "13px",
                        fontFamily: '"Open Sans", sans-serif',
                      }}
                    >
                      {row.cells.map((cell) => {
                        let alignStyle = "left"; // Default alignment
                        alignStyle =
                          cell.column.Header == "START DATE" ||
                          cell.column.Header == "STATE" || "YRS AT STRIVE"
                            ? "center"
                            : cell.column.alignStyle
                            ? cell.column.alignStyle
                            : alignStyle;
                        // // Adjust alignment based on data type
                        // if (typeof cell.value === "number") {
                        //   alignStyle = "right"; // Numeric values align right
                        // } else if (
                        //   Date.parse(cell.value) &&
                        //   cell.column.id !== "ZIP"
                        // ) {
                        //   //checking zip condition because every time zip will be in number with string
                        //   alignStyle = "center"; // Dates align center
                        // } else if (typeof cell.value === "boolean") {
                        //   alignStyle = "center"; // Boolean values align center
                        // }

                        return (
                          <td
                            {...cell.getCellProps()}
                            className={
    String(lastViewTeamMember) === String(row.original.contact_id || row.original.company_id)
      ? "last_visited_contact"
      : ""
  }
   data-contact-id={(row.original.contact_id || row.original.company_id).toString()}
                            style={{
                              padding: "16px", // Cell padding
                              border: "none", // Remove vertical lines
                              verticalAlign: "middle", // Center content vertically
                              textAlign: alignStyle, // Apply dynamic alignment
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    style={{
                      textAlign: "center",
                      height: "60px", // Consistent height for no data row
                      fontSize: "13px",
                      fontFamily: '"Open Sans", sans-serif',
                    }}
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
  </table>
          </div>
          <div
            style={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
            }}
          >
            <div style={{ display: "flex", gap: "8px", marginBottom: "1px" }}>
              <button
                className="button-new negative"
                onClick={() => handlePageChange(0)}
                disabled={pageOptions.pageIndex === 0}
              >
                {"<<"}
              </button>
              <button
                className="button-new negative"
                onClick={() => handlePageChange(pageIndex - 1)}
                disabled={pageOptions.pageIndex === 0}
              >
                Previous
              </button>
              <button
                className="button-new positive"
                onClick={() => handlePageChange(pageOptions.pageIndex + 1)}
                disabled={
                  pageOptions.pageIndex + 1 == pageCount || page.length == 0
                }
              >
                Next
              </button>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  marginBottom: "1px",
                }}
                className="tableListresult"
              >
                <span>
                  Page <strong>{pageOptions.pageIndex + 1}</strong> of{" "}
                  <strong>{pageCount}</strong>
                </span>
                <select
                  className="custom-select"
                  value={pageOptions.pageSize}
                  style={{
                    cursor: "pointer",
                  }}
                  disabled={page.length == 0}
                  onChange={(e) => {
                    const selectedValue = e.target && e.target.value; // Safely access e.target.value
                    if (selectedValue) {
                      setPageOptions((prev) => ({
                        ...prev,
                        pageSize: Number(selectedValue),
                        pageIndex: 0, // Reset to the first page
                      }));
                    }
                  }}
                >
                  {(moduleName === "team-members" ? [100, 500] : [25, 50, 100, 500]).map(
                    (size) => (
                      <option key={size} value={size}>
                        Show {size}&nbsp;&nbsp;&nbsp;
                      </option>
                    )
                  )}
                </select>
              </div>
              <button
                className="btn button-new negative"
                onClick={() => handlePageChange(pageCount - 1)}
                disabled={
                  pageOptions.pageIndex + 1 == pageCount || page.length == 0
                }
              >
                {">>"}
              </button> 
              <div className= {listVal.toLowerCase() === "team members" || listVal.toLowerCase() === "vendors" || listVal.toLowerCase() === "lenders" ?  "total-count-fixed-teams" : "total-count-fixed" } >
  <span >
  Total Count : {tableDataAllCount}
</span>
              </div>
            </div>
          </div>
        </div>
        {listVal.toLowerCase() === "team members" && renderPrintPage()}
      </div>
      {(isInvestor || isAgentList) && (
        <SearchPanel ref={searchPanelRef}>
          <nav className="Filter_nav">
            <div
              className="Filter_button"
              onClick={() => searchPanelRef.current && searchPanelRef.current.close()}
            >
              Close
            </div>
          </nav>
          {isAgentList ? (
            <AgentForm
              theme="dark"
              data={advFilterQuery}
              paneIndex={advPaneIndex}
              isFilter={true}
              showGroupFilter={supportsGroupFilter}
              ownerAgentId={ownerAgentId}
              handleSubmit={handleAdvancedApply}
              handleCancel={handleAdvancedClear}
              handleParentChange={handleAdvParentChange}
              handleParentDropdownChange={handleAdvParentDropdownChange}
              handlePaneChange={(key) => setAdvPaneIndex(key)}
            />
          ) : (
            <InvestorForm
              theme="dark"
              data={advFilterQuery}
              paneIndex={advPaneIndex}
              isFilter={true}
              showGroupFilter={supportsGroupFilter}
              ownerAgentId={ownerAgentId}
              handleSubmit={handleAdvancedApply}
              handleCancel={handleAdvancedClear}
              handleParentChange={handleAdvParentChange}
              handleParentDropdownChange={handleAdvParentDropdownChange}
              handlePaneChange={(key) => setAdvPaneIndex(key)}
            />
          )}
        </SearchPanel>
      )}
    </div>
  );
}

export default SampleTable;
